import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { Modal, Button, Table, Form } from 'react-bootstrap';
//External modules 
import moment from "moment-timezone";
//Utils 
import { RenderIf } from '../utils/RenderIf';
//API 
import { PaymentMethodFetchAPI } from '../../api/PaymentMethod';
import { BankConsilationFetchAPI } from '../../api/BankConsilation';
//Alerts 
import ErrorAlert from '../Alerts/ErrorAlert';
import SuccessAlert from '../Alerts/SuccessAlert';
import LoadingAlert from '../Alerts/LoadingAlert';
import Swal from 'sweetalert2';
//Components
import BankReconciliation from './Conciliation/BankReconciliation';
import ModalNewProposal from './Conciliation/ModalNewProposal';
import BankTemplate from './Modals/BankTemplate';
import LotInfoTransaction from './Modals/LotInfoTransaction';
import MovementMatchedModal from './Modals/MovementMatchedModal';

const BankStatements = () => {
    const [file, setFile] = useState(null);
    const [bankName, setBankName] = useState("");
    const [integrations, setIntegrations] = useState([]);
    let token = localStorage.getItem('x-access-token');
    let user = localStorage.getItem('user');
    user = JSON.parse(user);
    let { business_code } = useParams();
    const [bankStatements, setBankStatements] = useState([]);
    const [selectedStatement, setSelectedStatement] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showBankTemplate, setShowBankTemplate] = useState(false)
    const [showModalUpLot, setShowModalUpLot] = useState(false);
    const [selectedBank, setSelectedBank] = useState(null);
    const [min_date, setMinDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD'));
    const [max_date, setMaxDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000');
    const [status, setStatus] = useState(null);
    const [eventHandler, setEventHandler] = useState(0);
    const [eventHandlerShowTemplateModal, setEventHandlerShowTemplateModal] = useState(0);
    const [showMatchedModal, setShowMatchedModal] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState({
        reference: "",
        description: "",
        amount: 0,
        date: "", 
        justification: "",
    });
    // Upload of excel 
    const handleFileUpload = (e) => {
        //We just allow to upload  the file if the bank statement template is null
        const uploadfile = e.target.files[0];
        setFile(uploadfile);
        if (!uploadfile) return;
    };

    //Function to load the payment integrations 
    const loadPaymentIntegrations = async () => {
        try {
            const response = await PaymentMethodFetchAPI.getPaymentMethodIntegrations(token);
            setIntegrations(response.data.integrations);
        } catch (err) {
            ErrorAlert("Error al cargar las integraciones", err.message, "error");
            setIntegrations([]);
        }
    }

    //Function to get the bank statements
    const getBankStatements = async () => {
        try {
            const response = await BankConsilationFetchAPI.getBankStatements(token, business_code, min_date, max_date, status, selectedBank);
            setBankStatements(response.data.bankStatements);
        } catch (err) {
            setBankStatements([]);
        }
    }

    // Function to open details modal
    const openDetailsModal = (statement) => {
        setSelectedStatement(statement);
        setShowDetailsModal(true);
    };

    //Function to handle selected dates 
    const handleDateChange = (e) => {
        const { value } = e.target;
        const today = moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD');

        if (value === "today") {
            setMinDate(today);
            setMaxDate(today + 'T23:59:59.000');
        } else if (value === "yesterday") {
            setMinDate(moment().subtract(1, 'days').tz('America/Bogota').format('YYYY-MM-DD'));
            setMaxDate(moment().subtract(1, 'days').tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000');
        } else if (value === "last7Days") {
            setMinDate(moment().subtract(7, 'days').tz('America/Bogota').format('YYYY-MM-DD'));
            setMaxDate(today + 'T23:59:59.000');
        } else if (value === "last15Days") {
            setMinDate(moment().subtract(15, 'days').tz('America/Bogota').format('YYYY-MM-DD'));
            setMaxDate(today + 'T23:59:59.000');
        } else if (value === "last30Days") {
            setMinDate(moment().subtract(30, 'days').tz('America/Bogota').format('YYYY-MM-DD'));
            setMaxDate(today + 'T23:59:59.000');
        } else if (value === "last90Days") {
            setMinDate(moment().subtract(90, 'days').tz('America/Bogota').format('YYYY-MM-DD'));
            setMaxDate(today + 'T23:59:59.000');
        } else if (value === "lastSixMoth") {
            setMinDate(moment().subtract(6, 'months').tz('America/Bogota').format('YYYY-MM-DD'));
            setMaxDate(today + 'T23:59:59.000');
        } else if (value === "lastYear") {
            setMinDate(moment().subtract(1, 'years').tz('America/Bogota').format('YYYY-MM-DD'));
            setMaxDate(today + 'T23:59:59.000');
        }
    }

    //Function to update the bank statement 
    const updateBankStatement = async (status) => {
        try {

            //We check if all the transactions are matched
            const allTransactions = selectedStatement.transactions.every(transaction => transaction.status === "matched");
            if (!allTransactions) {
                ErrorAlert("Error al actualizar el estado del movimiento", "No se puede actualizar el estado del movimiento, ya que no todas las transacciones están conciliadas", "warning")
                return;
            } else {
                //We update the status of the bank statement
                await BankConsilationFetchAPI.updateBankStatement(token, status, selectedStatement._id);
                //We update the status of the selected statement
                const updatedStatement = { ...selectedStatement };
                updatedStatement.status = status;
                setSelectedStatement(updatedStatement);
                setEventHandler(eventHandler + 1);
                SuccessAlert("Estado actualizado", "El estado del movimiento fue actualizado exitosamente", "success")
                setShowDetailsModal(false);
            }
        } catch (err) {
            ErrorAlert("Error al actualizar el estado del movimiento", err.message, "error")
        }
    }

    //Function to delete a movement from a bank statement
    const deleteMovement = async (movementId) => {
        try {
            const response = await BankConsilationFetchAPI.removeBankStatementMovement(token, movementId, selectedStatement._id);
            if (response.status === 200) {
                //We pop the movement from the selected statement
                const updatedStatement = { ...selectedStatement };
                updatedStatement.transactions = updatedStatement.transactions.filter(transaction => transaction._id !== movementId);
                setSelectedStatement(updatedStatement);
                SuccessAlert("Movimiento eliminado", "El movimiento fue eliminado exitosamente", "success")
                setEventHandler(eventHandler + 1);
            } else {
                ErrorAlert("Error al eliminar el movimiento", response.data.message, "error")
            }
        } catch (err) {
            ErrorAlert("Error al eliminar el movimiento", err.message, "error")
        }

    }

    //Hook to detect change on the fields values
    useEffect(() => {
        setMinDate(min_date);
        setMaxDate(max_date);
        setStatus(status);
        setSelectedBank(selectedBank);
        //We get the bank statements when the user changes the values of the filters
        getBankStatements();
    }, [file, bankName, min_date, max_date, status, selectedBank])

    //Hook to load the initial data 
    useEffect(() => {
        loadPaymentIntegrations();
        getBankStatements()
    }, []);

    //Hook to load the table data 
    useEffect(() => {
        getBankStatements();
        setEventHandler(0)
    }, [eventHandler]);

    //Dropzone fILE
    const [fileName, setFileName] = useState('No hay ningún archivo seleccionado');

    const handleFileChange = (e) => {
        if (e.target.files.length > 0) {
            setFileName(e.target.files[0].name);
        } else {
            setFileName('No hay ningún archivo seleccionado');
        }
    };


    return (
        <main>

            <div className="row  mx-1 mt-3  rounded-3 bg-card-bank  py-3 p-lg-4">
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4  p-1 order-0 order-lg-0 order-md-0'>
                    <div className='d-flex justify-content-lg-between justify-content-md-start justify-content-center align-items-center'>
                        <h4 className=' fs-4 fw-bold text-left text-white'>
                            Movimientos Bancarios

                        </h4>
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4  p-1 order-2 order-lg-1 order-md-2">
                    <div className="d-flex justify-content-md-center justify-content-center">

                    </div>
                </div>

                <div className="col-12 col-sm-12 col-md-6 col-lg-8 col-xl-4 p-1 order-1 order-lg-2 order-md-1" id="target-div" >
                    <div className='d-flex  justify-content-md-end justify-content-lg-end  justify-content-center align-items-lg-center gap-1 p-1 '>
                        {/** Button to open the modal to create a new bank statement */}
                        <ModalNewProposal setEventHandlerShowTemplateModal={setEventHandlerShowTemplateModal} setEventHandler={setEventHandler} modalComponente={setShowBankTemplate} token={token} business_code={business_code} />

                        {/** Button to open the modal to create a new bank template */}
                        <BankTemplate eventHandlerShowTemplateModal={eventHandlerShowTemplateModal} setEventHandlerShowTemplateModal={setEventHandlerShowTemplateModal} integrations={integrations} token={token} business_code={business_code} />
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  p-1 order-2 order-lg-3 order-md-3">
                    <div className="w-100 mt-3">
                        <div className='row'>

                            <div className='col-md-3'>
                                <label for="exampleFormControlInput1" className="form-label text-light"><i class="uil uil-calendar-alt"></i> Período de Tiempo</label>
                                <select onChange={(e) => handleDateChange(e)} class="form-select" aria-label="Default select example">
                                    <option selected value="today">Hoy</option>
                                    <option value="yesterday">Ayer</option>form-label text-light
                                    <option value="last7Days">Últimos 7 días</option>
                                    <option value="last15Days">Últimos 15 días</option>
                                    <option value="last30Days">Últimos 30 días</option>
                                    <option value="last90Days">Últimos 90 días</option>
                                    <option value="lastSixMoth">Últimos 6 meses</option>
                                    <option value="lastYear">Últimos Año</option>
                                </select>
                            </div>
                            <div className='col-md-3'>
                                <label for="exampleFormControlInput1" className="form-label text-light"><i class="uil uil-university"></i> Banco</label>
                                <select onChange={(e) => setSelectedBank(e.target.value)} class="form-select" aria-label="Default select example">
                                    <option value={"null"} selected>Todos</option>
                                    {
                                        integrations.map((integration, index) => (
                                            <option key={index} value={integration.name}>
                                                {integration.name}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className='col-md-3'>
                                <label for="exampleFormControlInput1" className="form-label text-light"><i class="uil uil-list-ul"></i> Estado</label>
                                <select onChange={(e) => setStatus(e.target.value)} class="form-select" aria-label="Default select example">
                                    <option selected value={"null"}>Todos los estados</option>
                                    <option value="pending">Pendiente</option>
                                    <option value="completed">Conciliados</option>
                                </select>
                            </div>

                            <div className='col-md-3'>
                                <label for="exampleFormControlInput1" className="form-label text-light"><i class="uil uil-sliders-v-alt"></i> Avanzado </label>
                                <button type="button" className="btn btn-light d-block w-100">Personalizar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-between align-items-center mt-4'>
                <h5>
                    Listado de Propuestas
                </h5>

                <div className='d-flex justify-content-end gap-2'>
                    <button className='btn btn-outline-primary btn-sm '><i class="uil uil-file-download"></i>Descargar de Conciliaciones </button>
                    <button className='btn btn-outline-primary btn-sm '><i class="uil uil-file-download-alt"></i> Descargar de Conciliaciones detalladas  </button>
                </div>
            </div>

            {/** Table of bank statements */}
            <table className="table table-hover mt-2 border">
                <thead>
                    <tr className='table-dark'>
                        <th >Nombre de la propuesta</th>
                        <th >Banco</th>
                        <th >Fecha de creacion</th>
                        <th >Codigo del movimiento</th>
                        <th >Estado</th>
                        <th >Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {bankStatements.length > 0 ? (
                        bankStatements.map((statement) => (
                            <tr key={statement._id} className="hover:bg-gray-100">
                                <td >{statement.name !== undefined ? statement.name : "No registrado"}</td>
                                <td >{statement.bank_name}</td>
                                <td >{new Date(statement.createdAt).toLocaleDateString()}</td>
                                <td >{statement.code}</td>
                                <td >{statement.status}</td>
                                <RenderIf isTrue={statement.status === "pending"}>
                                    <td >{
                                        <button onClick={() => openDetailsModal(statement)} className="btn btn-primary">
                                            <i className="uil uil-pen"></i>
                                        </button>
                                    }</td>
                                </RenderIf>

                                <RenderIf isTrue={statement.status === "completed"}>
                                    <td >
                                        <button onClick={() => openDetailsModal(statement)} className="btn btn-primary">
                                            <i className="uil uil-eye"></i>
                                        </button>
                                    </td>
                                </RenderIf>

                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5" className="text-center border p-4">
                                No data available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <Modal
                show={showBankTemplate}
                onHide={() => setShowBankTemplate(false)}
                size='large'
                centered>
                <Modal.Body>

                    <div className='position-relative '>

                        <div className='position-absolute top-0 start-100 translate-middle mt-2 '>
                            <div className='me-3'>
                                <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1"
                                    type="button" title='Cerrar'
                                    onClick={() => setShowBankTemplate(false)}

                                >
                                    <i class="uil uil-multiply"></i>
                                </button>
                            </div>
                        </div>
                        <h2 className="title-main-login  text-center ">
                            Crear Nueva Plantilla Bancaria
                        </h2>

                        <div>
                            <div className=" p-3 bg-white rounded-3 border mt-5">
                                <h6 className="fw-semibold">Subir Archivo </h6>
                                <div className="dropzone-container">
                                    <label htmlFor="dropzone-file" className="dropzone-label">
                                        <div className="dropzone-content">
                                            <svg
                                                className="dropzone-icon"
                                                aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 20 16"
                                            >
                                                <path
                                                    stroke="currentColor"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                                />
                                            </svg>
                                            <p className="dropzone-text">
                                                <span className="dropzone-bold">Haga clic para cargar archivo de Estado de Cuenta Bancario </span>
                                            </p>

                                            <p className="file-name">{fileName}</p>
                                        </div>
                                        <input
                                            id="dropzone-file"
                                            type="file"
                                            accept=".xlsx, .xls"
                                            className="dropzone-input"
                                            onChange={(event) => {
                                                handleFileUpload(event);
                                                handleFileChange(event);
                                            }}
                                        />
                                    </label>
                                </div>
                            </div>
                            {/* 2 */}
                            <Form.Label>Seleccione la integracion a guardar:</Form.Label>
                            <Form.Select
                                value={bankName}
                                onChange={(e) => { setBankName(e.target.value); }}
                            >
                                <option value="">Seleccione...</option>
                                {integrations.map((integration, index) => (
                                    <option key={index} value={integration.name}>
                                        {integration.name}
                                    </option>
                                ))}
                            </Form.Select>



                            <div className="mt-3 d-flex justify-content-end">
                                <button className="btn btn-save-sp" type="submit">
                                    Guardar
                                </button>
                            </div>
                        </div>
                    </div>



                </Modal.Body>
            </Modal >
            {/* Modal to show the details of the statement */}
            <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} centered size='xl' backdrop="static"
                keyboard={false} >

                <Modal.Body>
                    <div className="position-relative">
                        <div className='position-absolute top-0 start-100 translate-middle mt-2 '>
                            <div className='me-3'>
                                <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1"
                                    type="button" title='Cerrar'
                                    onClick={() => setShowDetailsModal(false)}

                                >
                                    <i class="uil uil-multiply"></i>
                                </button>
                            </div>
                        </div>
                        <h2 className="title-main-login  text-center ">
                            Detalles del Estado Bancario
                        </h2>

                        {selectedStatement && (
                            <>
                                <div className="d-flex justify-content-between pb-2 align-items-center">
                                    <h5>Transacciones Registradas</h5>
                                </div>
                                <div class="wrapper-bank">
                                    <table className="table table-hover mt-5">
                                        <thead>
                                            <tr className='bg-primary text-white'>
                                                <th>Fecha</th>
                                                <th>Referencia</th>
                                                <th>Descripción</th>
                                                <th>Monto</th>
                                                <th>Estado</th>
                                                <th>Acciones</th>
                                                <th> </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedStatement.transactions.map((transaction, index) => (
                                                <tr key={index}>
                                                    <td>{transaction.date}</td>
                                                    <td>{transaction.reference}</td>
                                                    <td>{transaction.description}</td>
                                                    <td>{transaction.amount}</td>
                                                    <td>{transaction.status === "pending" ?
                                                        <span className='rounded-pill border text-secondary small px-2'> <i class="uil uil-spinner"></i> Pendiente</span>
                                                        :
                                                        <span className='rounded-pill text-on icon-on small px-2'> <i class="uil uil-check"></i> Conciliada</span>
                                                    }
                                                    </td>

                                                    {transaction.status === "pending" ?
                                                        <>
                                                            <td>
                                                                <LotInfoTransaction
                                                                    reference={transaction.reference}
                                                                    description={transaction.description}
                                                                    amount={transaction.amount}
                                                                    date={transaction.date}
                                                                    minSelectedDate={min_date}
                                                                    maxSelectedDate={max_date}
                                                                    user={user}
                                                                    token={token}
                                                                    business_code={business_code}
                                                                    bankStatementId={selectedStatement._id}
                                                                    setSelectedStatement={setSelectedStatement}
                                                                    selectedTransactionStatementIndex={index}
                                                                    selectedStatement={selectedStatement}
                                                                    setBankStatementEventHandler={setEventHandler}
                                                                ></LotInfoTransaction>
                                                            </td>
                                                            <td>
                                                                <button
                                                                    onClick={() => {
                                                                        Swal.fire({
                                                                            title: '¿Está seguro de eliminar este movimiento?',
                                                                            text: "No podrás revertir esto!",
                                                                            icon: 'warning',
                                                                            showCancelButton: true,
                                                                            confirmButtonColor: '#3085d6',
                                                                            cancelButtonColor: '#d33',
                                                                            confirmButtonText: 'Sí, eliminarlo!'
                                                                        }).then((result) => {
                                                                            if (result.isConfirmed) {
                                                                                LoadingAlert("Eliminando movimiento", "Por favor espere un momento mientras eliminamos el movimiento", "info")
                                                                                deleteMovement(transaction._id);
                                                                            }
                                                                        })
                                                                    }}
                                                                    className='btn btn-danger  bg-white btn-sm  fw-normal text-primary  border-0 rounded-2 text-nowrap '
                                                                >
                                                                    <i class="uil uil-trash-alt"></i>  Eliminar movimiento
                                                                </button>
                                                            </td>
                                                        </>
                                                        :
                                                        <>
                                                            <td>
                                                                <button onClick={()=> {setShowMatchedModal(true); setSelectedTransaction(transaction)}} className='btn btn-primary'> <i class="uil uil-eye"></i> </button>
                                                            </td>
                                                            <td> 
                                                            </td>
                                                        </>
                                                    }
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {/** Button to open the modal to upload a new lot */}
                    <RenderIf isTrue={selectedStatement && selectedStatement.status === "pending"}>
                        <Button variant="success" onClick={() => setShowDetailsModal(false)}>
                            Guardar Cambios
                        </Button>
                        <Button variant="primary" onClick={() => updateBankStatement("completed")}>
                            Conciliar Propuesta
                        </Button>
                    </RenderIf>
                    {/** Button to close the modal  */}
                    <RenderIf isTrue={selectedStatement && selectedStatement.status === "completed"}>
                        <Button variant="primary" onClick={() => setShowDetailsModal(false)}>
                            Cerrar
                        </Button>
                    </RenderIf>

                </Modal.Footer>
            </Modal>
            {/* Modal to show the details of the statement */}
            <Modal show={showModalUpLot} onHide={() => setShowModalUpLot(false)} size="lg" centered>
                <Modal.Body>
                    <div className="position-relative">
                        <div className='position-absolute top-0 start-100 translate-middle mt-2 '>
                            <div className='me-3'>
                                <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1"
                                    type="button" title='Cerrar'
                                    onClick={() => setShowModalUpLot(false)}

                                >
                                    <i class="uil uil-multiply"></i>
                                </button>
                            </div>
                        </div>
                        <h2 className="title-main-login  text-center ">
                            Subir Lote para conciliar

                        </h2>

                        <div className=" p-3 bg-white rounded-3 border mt-5">
                            <h6 className="fw-semibold">Subir Archivo </h6>
                            <div className="dropzone-container">
                                <label htmlFor="dropzone-file" className="dropzone-label">
                                    <div className="dropzone-content">
                                        <svg
                                            className="dropzone-icon"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 20 16"
                                        >
                                            <path
                                                stroke="currentColor"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                            />
                                        </svg>
                                        <p className="dropzone-text">
                                            <span className="dropzone-bold">Haga clic para cargar archivo de Estado de Cuenta Bancario </span>
                                        </p>

                                        <p className="file-name">{fileName}</p>
                                    </div>
                                    <input
                                        id="dropzone-file"
                                        type="file"
                                        accept=".xlsx, .xls"
                                        className="dropzone-input"
                                        onChange={(event) => {
                                            handleFileChange(event);
                                        }}
                                    />
                                </label>
                            </div>
                        </div>

                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={() => setShowModalUpLot(false)}>
                        Guardar Cambios
                    </Button>

                </Modal.Footer>
            </Modal>
            {/* Modal to show the details of the statement */}
            <MovementMatchedModal token={token} showModal={showMatchedModal} setShowMatchedModal={setShowMatchedModal} selectedStatement={selectedStatement}  selectedTransactionStatement={selectedTransaction}/>
        </main>
    );
};

export default BankStatements;
